import React from 'react';
import './ProcessingStatus.css';

const ProcessingStatus = ({ progress, status, currentPage, totalPages }) => {
  return (
    <div className="processing-status">
      <div className="status-header">
        <div className="spinner"></div>
        <h3>Processing Images...</h3>
      </div>
      
      <div className="progress-container">
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <span className="progress-text">{Math.round(progress)}%</span>
      </div>
      
      <div className="status-details">
        <p className="current-status">{status}</p>
        <p className="page-info">
          Page {currentPage} of {totalPages}
        </p>
      </div>
      
      <div className="status-tips">
        <p>Please wait while we process your images...</p>
        <p>This may take a few minutes depending on image size.</p>
      </div>
    </div>
  );
};

export default ProcessingStatus;